import React, { useMemo } from 'react';
import StoreLocator from '../../../../../pages/Dealers/BuyLocal/StoreLocator';
import { useQuery } from '@apollo/client';
import { GET_STORE_LOCATOR_QUERY } from '../../../../../pages/Dealers/BuyLocal/query';

var BuyLocalContent = function BuyLocalContent() {
  var options = [{
    label: 'What best describes you? *',
    value: ''
  }, {
    label: 'Label Two',
    value: 'Label Two'
  }];

  var _useQuery = useQuery(GET_STORE_LOCATOR_QUERY, {
    fetchPolicy: 'cache-and-network'
  }),
      data = _useQuery.data,
      loading = _useQuery.loading,
      error = _useQuery.error;

  var mapStores = function mapStores(storesArray) {
    var stores = [];

    if (storesArray !== null && storesArray !== void 0 && storesArray.length) {
      storesArray.map(function (store) {
        stores.push({
          city: store.city,
          country: store.country,
          fax: store.fax,
          group: store.group,
          lat: parseFloat(store.latitude),
          lng: parseFloat(store.longitude),
          name: store.name,
          telephone: store.phone,
          state: store.state,
          store_id: store.store_id,
          street: store.street,
          website: store.website,
          zip: store.zip
        });
      });
    }

    return stores;
  };

  var stores = useMemo(function () {
    var _data$getStoreLocator;

    return mapStores(data === null || data === void 0 ? void 0 : (_data$getStoreLocator = data.getStoreLocator) === null || _data$getStoreLocator === void 0 ? void 0 : _data$getStoreLocator.stores);
  }, [data]);
  return React.createElement(React.Fragment, null, React.createElement("p", {
    className: "text-center text-bronze"
  }, "Only Available in US & Canada"), React.createElement(StoreLocator, {
    classes: {
      root: 'mt-4',
      pdpSearch: 'mr-0 mb-4'
    },
    stores: stores // hideGoogleMaps={true}

  }));
};

export default BuyLocalContent;